export * from './value-of.pipe';



// WEBPACK FOOTER //
// ./node_modules/@rx/table/pipes/index.ts